import Component from 'vue-class-component';
import VueCqrs from '@cqrs/vue-component-cqrs';
import * as q from '@Alternatives/Alternatives/Domain/queries';

@Component
export default class AlternativesQueries extends VueCqrs
{
	runAlternativesConnectorProviderConfigQueryV1(organizationUnitId: string, workspaceId: any, projectId: any, viewId: any, attributesIds: any)
	{
		const query = q.buildAlternativesConnectorProviderConfigQueryV1(organizationUnitId, workspaceId, projectId, viewId, attributesIds);
		this.$query(query);
	}

	runAlternativesByViewDefIdQueryV1(workspaceId: number, projectId: number, viewDefId: string)
	{
		const query = q.buildAlternativesByViewDefIdQueryV1(workspaceId, projectId, viewDefId);
		this.$query(query);
	}

	runDependencyDialogAlternativesQueryV1(workspaceId: number, projectId: number, alternativeId: string)
	{
		const query = q.buildDependencyDialogAlternativesQueryV1(workspaceId, projectId, alternativeId);
		this.$query(query);
	}

	runAlternativeQueryV1(workspaceId: number, projectId: number, alternativesListId: number, alternativeId: string, includeAttributeValues: boolean)
	{
		const query = q.buildAlternativeQueryV1(workspaceId, projectId, alternativesListId, alternativeId, includeAttributeValues);
		this.$query(query);
	}


	runAlternativeDashboardQueryV1(workspaceId: number, projectId: number, alternativeId: string)
	{
		const query = q.buildAlternativeDashboardQueryV1(workspaceId, projectId, alternativeId);
		this.$query(query);
	}

	runAlternativeLogsQueryV1(workspaceId: number, projectId: number, alternativeId: string)
	{
		const query = q.buildAlternativeLogsQueryV1(workspaceId, projectId, alternativeId);
		this.$query(query);
	}

	runAlternativeLogEntryQueryV1(workspaceId: number, alternativeId: string, activityLogEntryId: string)
	{
		const query = q.buildAlternativeLogEntryQueryV1(workspaceId, alternativeId, activityLogEntryId);
		this.$query(query);
	}

	runLastAlternativeLogEntryQueryV1(workspaceId: number, projectId: number, alternativeId: string)
	{
		const query = q.buildLastAlternativeLogEntryQueryV1(workspaceId, projectId, alternativeId);
		this.$query(query);
	}


	runAlternativeAttachmentsQueryV1(workspaceId: number, projectId: number, alternativeId: string)
	{
		const query = q.buildAlternativeAttachmentsQueryV1(workspaceId, projectId, alternativeId);
		this.$query(query);
	}

	runAlternativeAttachmentQueryV1(workspaceId: number, alternativeId: string, attachmentId: string)
	{
		const query = q.buildAlternativeAttachmentQueryV1(workspaceId, alternativeId, attachmentId);
		this.$query(query);
	}

	runImportAlternativesPageQueryV1(workspaceId: number, projectId: number, alternativesListId: number, blobId: string)
	{
		const query = q.buildImportAlternativesPageQueryV1(workspaceId, projectId, alternativesListId, blobId);
		this.$query(query);
	}

	runEditAlternativePageQueryV1(alternativeId: string, formId: number | null)
	{
		const query = q.buildEditAlternativePageQueryV1(alternativeId, formId);
		this.$query(query);
	}

	runAlternativeEditorPreviewQueryV1(workspaceId: number, projectId: number, alternativesListId: number, formDefId: number)
	{
		const query = q.buildAlternativeEditorPreviewQueryV1(workspaceId, projectId, alternativesListId, formDefId);
		this.$query(query);
	}

	runAlternativeEditorCreationQueryV1(workspaceId: number, projectId: number, alternativesListId: number, formId: number | null)
	{
		const query = q.buildAlternativeEditorCreationQueryV1(workspaceId, projectId, alternativesListId, formId);
		this.$query(query);
	}

	runAlternativeEditorEditionQueryV1(workspaceId: number, projectId: number, alternativesListId: number, alternativeId: string, formId: number | null)
	{
		const query = q.buildAlternativeEditorEditionQueryV1(workspaceId, projectId, alternativesListId, alternativeId, formId);
		this.$query(query);
	}
}
